import MultiSelectField from "../Placementdb/MultiSelectField";

const EmployeeFilters = ({

    availableBranches,
    departments,

    selectedBranches,
    selectedDepartments,
    selectedRoles,
    selectedAccess,
    setSelectedAccess,
    lastLoginFilter,
    loginFrom,
    setLoginFrom,

    loginTo,
    setLoginTo,
    setLastLoginFilter,
    setSelectedBranches,
    setSelectedDepartments,
    setSelectedRoles,

    onApply,
    onClear

}) => {

    const roleOptions = [
        "Trainer",
        "Placement officer"
    ];
    const loginOptions = [
        { label: "Last 1 Day", value: "1" },
        { label: "Last 7 Days", value: "7" },
        { label: "Last 14 Days", value: "14" },
        { label: "Last 30 Days", value: "30" },
        { label: "Never Logged In", value: "never" }
    ];

    return (

        <div className="advanced-filters-panel">

            <div className="filters-grid">

                <MultiSelectField
                    label="Branch"
                    options={availableBranches}
                    selectedValues={selectedBranches}
                    onChange={setSelectedBranches}
                    placeholder="Select branches..."
                    searchPlaceholder="Search branch..."
                />

                <MultiSelectField
                    label="Department"
                    options={departments}
                    selectedValues={selectedDepartments}
                    onChange={setSelectedDepartments}
                    placeholder="Select departments..."
                    searchPlaceholder="Search department..."
                />

                <MultiSelectField
                    label="Role"
                    options={roleOptions}
                    selectedValues={selectedRoles}
                    onChange={setSelectedRoles}
                    placeholder="Select roles..."
                    searchPlaceholder="Search role..."
                />

                <div className="filter-group">
                    <label className="filter-label">
                        Access Status
                    </label>

                    <select
                        value={selectedAccess}
                        onChange={(e) =>
                            setSelectedAccess(e.target.value)
                        }
                        className="filter-select"
                    >
                        <option value="">
                            All
                        </option>

                        <option value="true">
                            True
                        </option>

                        <option value="false">
                            False
                        </option>
                    </select>
                </div>

                <div className="filter-group">

                    <label className="filter-label">
                        Last Login
                    </label>

                    <select
                        value={lastLoginFilter}
                        onChange={(e) =>
                            setLastLoginFilter(e.target.value)
                        }
                        className="filter-select"
                    >
                        <option value="">
                            All
                        </option>

                        <option value="1">
                            Last 1 Day
                        </option>

                        <option value="7">
                            Last 7 Days
                        </option>

                        <option value="14">
                            Last 14 Days
                        </option>

                        <option value="30">
                            Last 30 Days
                        </option>

                        <option value="never">
                            Never Logged In
                        </option>

                    </select>

                </div>

                <div className="date-filter-group">

                    <label className="filter-label">
                        Login From
                    </label>

                    <input
                        type="date"
                        value={loginFrom}
                        disabled={!!lastLoginFilter}
                        onChange={(e) => {

                            setLoginFrom(
                                e.target.value
                            );

                            if (e.target.value) {

                                setLastLoginFilter("");

                            }

                        }}
                        className="date-filter-input"
                    />

                </div>

                <div className="date-filter-group">

                    <label className="filter-label">
                        Login To
                    </label>

                    <input
                        type="date"
                        value={loginTo}
                        disabled={!!lastLoginFilter}
                        onChange={(e) => {

                            setLoginTo(
                                e.target.value
                            );

                            if (e.target.value) {

                                setLastLoginFilter("");

                            }

                        }}
                        className="date-filter-input"
                    />

                </div>


            </div>


            <div className="filters-actions">

                <button
                    className="clear-btn"
                    onClick={onClear}
                >
                    Clear Filters
                </button>



            </div>

        </div>

    );
};

export default EmployeeFilters;